"use client"
import React from 'react'
import SearchDefault from '@/library/blocks/searchs/SearchDefault';

export default function ECSearch(props) {
  const { onChange, placeholder } = props
  return (
    <>
      <SearchDefault placeholder={placeholder} onChange={onChange}/>
    </>
  )
}
